export const COLOR_THEME_KEYS = {
  header: 'header',
  appBackground: 'appBackground',
  component: 'component',
  border: 'border',
  text: 'text',
  buttonText: 'buttonText',
  proColor: 'proColor',
  conColor: 'conColor',

  disabled: 'disabled',
  overlay: 'overlay',
  componentNoOpacity: 'componentNoOpacity',
  lowContrastBorder: 'lowContrastBorder',
  secondaryText: 'secondaryText',

  neutral: 'neutral',
  negative: 'negative',
  positive: 'positive',

  avatarBackgroundColor: 'avatarBackgroundColor',
  buttonColor: 'buttonColor',
  primaryCtaButton: 'primaryCtaButton',
  primaryEyeCatchingCtaButton: 'primaryEyeCatchingCtaButton',
  badge: 'badge',
  error: 'error',
  warning: 'warning',
  hoverComponentBackground: 'hoverComponentBackground',
};

export const CUSTOMIZE_COLOR_THEME_KEYS = [
  COLOR_THEME_KEYS.appBackground,
  COLOR_THEME_KEYS.componentNoOpacity,
  COLOR_THEME_KEYS.text,
  COLOR_THEME_KEYS.primaryCtaButton,
  COLOR_THEME_KEYS.buttonText,
  COLOR_THEME_KEYS.positive,
  COLOR_THEME_KEYS.neutral,
  COLOR_THEME_KEYS.negative,
  COLOR_THEME_KEYS.proColor,
  COLOR_THEME_KEYS.conColor,
];
